/* ES wishlist runtime extracted from snippets/swym-custom.liquid. Keep logic conservative. */
function swymCallbackFn(swat){
    
    try { window.__esSwat = swat; } catch(e) {}
    // ES FIX (2026-01-29): Do NOT let Swym auto-initialize our unified buttons.
    // We handle state + click using JS APIs (variant-first) so swatch switching cannot break.
    try {
      esPruneCollectionWishlistButtons();
      esPruneGlobalWishlistDuplicates();
      esCleanupUnifiedWishlistButtonInternals();
      if (window.esWishlistSyncAll) window.esWishlistSyncAll();
    } catch (e) {}

    // ES CLEAN: remove any auto-injected/legacy wishlist buttons inside product cards,
    // keeping only the inline heart placed in the price row (inside .es-wishlist-inline).
    function esPruneCollectionWishlistButtons(){
      try {
        var cards = document.querySelectorAll('.product-item-v1');
        if (!cards || !cards.length) return;
        cards.forEach(function(card){
          var btns = card.querySelectorAll('.swym-button.swym-add-to-wishlist, .swym-button.swym-add-to-wishlist-view-product, .swym-button.swym-add-to-wishlist-product');
          if (!btns || !btns.length) return;
          btns.forEach(function(btn){
            if (!btn.closest('.es-wishlist-inline')) {
              if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
            }
          });
        });
      } catch (e) {}
    }

    // ES CLEAN: remove any auto-injected duplicate Swym wishlist buttons on PDP / Quickview,
    // keeping only our unified component buttons (marked by .es-wishlist-btn).
    function esPruneGlobalWishlistDuplicates(){
      try {
        var scopes = document.querySelectorAll('.template-product, .quickview-product, .tshopify-popup');
        if(!scopes || !scopes.length) return;
        scopes.forEach(function(scope){
          var btns = scope.querySelectorAll('button.swym-button.swym-add-to-wishlist, button.swym-button.swym-add-to-wishlist-view-product, button.swym-button.swym-add-to-wishlist-product');
          btns.forEach(function(btn){
            if(!btn.classList.contains('es-wishlist-btn')){
              if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
            }
          });
        });
      } catch(e) {}
    }

    // ES CLEAN: Swym may inject its own heart/icon markup INSIDE our buttons (or via wrappers),
    // resulting in "two hearts" next to Add to Cart. Keep only our SVG (inside .es-swym-heart).
    function esCleanupUnifiedWishlistButtonInternals(){
      try {
        var scopes = document.querySelectorAll('.template-product, .quickview-product, .tshopify-popup');
        if(!scopes || !scopes.length) return;
        scopes.forEach(function(scope){
          // If our component is rendered twice by any layout, keep only the first per container.
          var containers = scope.querySelectorAll('.es-wishlist-pdp, .es-wishlist-qv');
          containers.forEach(function(c){
            var ours = c.querySelectorAll('.es-wishlist-btn');
            for (var i = 1; i < ours.length; i++) {
              try { ours[i].parentNode && ours[i].parentNode.removeChild(ours[i]); } catch(e) {}
            }
          });

          var btns = scope.querySelectorAll('.es-wishlist-btn');
          btns.forEach(function(btn){
            // Remove any direct children that are not our icon container.
            var children = Array.prototype.slice.call(btn.children || []);
            children.forEach(function(ch){
              if(!ch) return;
              // Keep the node if it IS our icon container, or it CONTAINS our icon.
              if (ch.classList && ch.classList.contains('es-swym-heart')) return;
              try {
                if (ch.querySelector && ch.querySelector('.es-swym-heart')) return;
              } catch(e) {}

              // Otherwise, prune common Swym injections.
              var cls = (ch.className || '').toString();
              var tag = (ch.tagName || '').toUpperCase();
              if (cls.indexOf('swym') !== -1 || tag === 'I' || tag === 'SVG' || tag === 'IMG'){
                try { ch.parentNode && ch.parentNode.removeChild(ch); } catch(e) {}
              }
            });

            // Also remove any injected icon elements deeper inside the button,
            // but keep our SVG (marked with data-es-heart="1").
            try {
              var injectedSvgs = btn.querySelectorAll('svg:not([data-es-heart="1"])');
              injectedSvgs.forEach(function(s){ try { s.parentNode && s.parentNode.removeChild(s); } catch(e) {} });
              var injectedIcons = btn.querySelectorAll('.swym-icon, [class*="swym-icon"], i');
              injectedIcons.forEach(function(ic){
                // don't remove if it's within our icon wrapper
                try { if (ic.closest && ic.closest('.es-swym-heart')) return; } catch(e) {}
                try { ic.parentNode && ic.parentNode.removeChild(ic); } catch(e) {}
              });
            } catch(e) {}
          });
        });
      } catch(e) {}
    }

    esPruneCollectionWishlistButtons();
      esPruneGlobalWishlistDuplicates();
      esCleanupUnifiedWishlistButtonInternals();

    // IMPORTANT (ES FIX 2026-01-29): Do NOT let Swym auto-initialize our unified buttons.
    // We control the click behavior + state sync (variant-first) via JS APIs below.
    if (!window.__esSwymQvPruneBound) {
      window.__esSwymQvPruneBound = true;
      document.addEventListener("swym:qv-loaded", function(){
        esPruneCollectionWishlistButtons();
        esPruneGlobalWishlistDuplicates();
        esCleanupUnifiedWishlistButtonInternals();
        try { if (window.esWishlistSyncAll) window.esWishlistSyncAll(); } catch(e) {}
      });
    }
  }
  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  if (!window.__esSwymCallbackFnAdded) {
    window.__esSwymCallbackFnAdded = true;
    window.SwymCallbacks.push(swymCallbackFn);
  }


/* ES UNIFIED WISHLIST STATE SYNC (variant-first, no flash) */
(function(){
  var IDS_KEY = 'es_swym_wishlist_keys_v2';
  var LEGACY_KEY = 'es_swym_wishlist_product_ids';
  var HAS_KEY = 'es_swym_wishlist_has_items';
  var STYLE_ID = 'es-wl-prestyle';
  var ACTIVE = 'rgba(17,17,17,.58)';

  var __esKeySet = null;
  var __cacheWriteTimer = null;
  var __syncTimer = null;

  function norm(v){
    if (v == null) return '';
    var s = String(v).trim();
    if (!s || s === 'null' || s === 'undefined') return '';
    return s;
  }

  function safeParse(str){
    if (!str) return null;
    try { return JSON.parse(str); } catch(e) { return null; }
  }

  function addKey(set, key){
    key = norm(key);
    if (!key) return;
    if ((key.indexOf('v:') === 0 || key.indexOf('p:') === 0) && key.length > 2) {
      set.add(key);
    } else {
      // Legacy plain ids: assume variant-first to avoid marking all variants.
      set.add('v:' + key);
    }
  }

  function keyFromItem(obj){
    if (!obj || typeof obj !== 'object') return '';
    var epi = obj.epi || obj.variantId || obj.variant_id || obj.vid;
    if (obj.product && !epi) epi = obj.product.epi || obj.product.variantId || obj.product.variant_id;
    var empi = obj.empi || obj.productId || obj.product_id || obj.id || obj.pid;
    if (obj.product && !empi) empi = obj.product.id || obj.product.empi || obj.product.productId || obj.product.product_id;
    epi = norm(epi); empi = norm(empi);
    if (epi) return 'v:' + epi;
    if (empi) return 'p:' + empi;
    return '';
  }

  function extractKeys(set, obj){
    if (!obj) return;
    if (Array.isArray(obj)) {
      for (var i=0;i<obj.length;i++) extractKeys(set, obj[i]);
      return;
    }
    var t = typeof obj;
    if (t === 'string' || t === 'number') {
      addKey(set, obj);
      return;
    }
    if (t !== 'object') return;

    var k = keyFromItem(obj);
    if (k) {
      addKey(set, k);
      return;
    }

    // Walk nested common containers
    if (obj.items) extractKeys(set, obj.items);
    if (obj.products) extractKeys(set, obj.products);
    if (obj.data) extractKeys(set, obj.data);
    if (obj.list) extractKeys(set, obj.list);
  }

  function safeReadKeys(){
    var set = new Set();

    try {
      if (window.localStorage) {
        extractKeys(set, safeParse(localStorage.getItem(IDS_KEY)));

        // Migrate old cache only if the new cache is empty
        if (set.size === 0) {
          extractKeys(set, safeParse(localStorage.getItem(LEGACY_KEY)));
        }

        // Known Swym cache keys (varies by build)
        var candidates = [
          'swym_wishlist', 'swym-wishlist', 'swymWishlist',
          'swym_wishlist_products', 'swym-wishlist-products',
          'swym-wishlist-items', 'swym_wishlist_items'
        ];
        for (var i=0;i<candidates.length;i++) {
          try { extractKeys(set, safeParse(localStorage.getItem(candidates[i]))); } catch(e) {}
        }

        // Last resort: scan any localStorage keys that look like Swym wishlist caches
        try {
          for (var i2=0;i2<localStorage.length;i2++) {
            var k = localStorage.key(i2) || '';
            if (k.toLowerCase().indexOf('swym') === -1) continue;
            if (k.toLowerCase().indexOf('wish') === -1) continue;
            var v = localStorage.getItem(k) || '';
            if (!v || v.length < 20) continue;
            if (v.indexOf('epi') === -1 && v.indexOf('empi') === -1 && v.indexOf('variant') === -1 && v.indexOf('product') === -1) continue;
            extractKeys(set, safeParse(v));
          }
        } catch(e) {}
      }
    } catch(e) {}

    return Array.from(set);
  }

  function ensureSet(){
    if (__esKeySet) return __esKeySet;
    __esKeySet = new Set(safeReadKeys());
    return __esKeySet;
  }

  function scheduleCacheWrite(){
    try { if (__cacheWriteTimer) clearTimeout(__cacheWriteTimer); } catch(e) {}
    __cacheWriteTimer = setTimeout(function(){
      try {
        if (!window.localStorage) return;
        localStorage.setItem(IDS_KEY, JSON.stringify(Array.from(__esKeySet || [])));
      } catch(e) {}
    }, 150);
  }

  function setHasItemsFlag(){
    try {
      var n = (__esKeySet && __esKeySet.size) ? __esKeySet.size : 0;
      // ES: do not drive header badge from cached keys (prevents false flash on empty wishlist).
      // ES: do not persist global 'has items' from cached keys; use confirmed count from Swym callback.
} catch(e) {}
  }

  function btnKey(btn){
    if (!btn) return '';
    var vid = norm(btn.getAttribute('data-variant-id') || (btn.dataset && btn.dataset.variantId));
    if (vid) return 'v:' + vid;
    var pid = norm(btn.getAttribute('data-product-id') || (btn.dataset && btn.dataset.productId));
    if (pid) return 'p:' + pid;
    return '';
  }

  function setAdded(el, on){
    if (!el || !el.classList) return;
    if (on) el.classList.add('es-added');
    else el.classList.remove('es-added');
  }

  function applyToBtn(btn){
    var key = btnKey(btn);
    if (!key) return;
    setAdded(btn, ensureSet().has(key));
  }
  window.esWishlistApplyToButton = applyToBtn;

  function updateButtonsByKey(key, on){
    try {
      if (!key) return;
      var btns = document.querySelectorAll('button.es-wishlist-btn');
      for (var i=0;i<btns.length;i++) {
        var b = btns[i];
        if (btnKey(b) === key) setAdded(b, on);
      }
    } catch(e) {}
  }

  // Used by counter script when wishlist becomes empty
  window.esWishlistClearAllHearts = function(){
    try {
      var btns = document.querySelectorAll('button.es-wishlist-btn.es-added');
      for (var i=0;i<btns.length;i++) btns[i].classList.remove('es-added');
      var st = document.getElementById(STYLE_ID);
      if (st) st.textContent = '';
      document.documentElement.classList.remove('es-wishlist-has-items');
      try { if (window.localStorage) localStorage.setItem(HAS_KEY, '0'); } catch(e) {}
      try { if (window.localStorage) localStorage.setItem(IDS_KEY, '[]'); } catch(e) {}
    } catch(e) {}
  };

  function buildPreCss(keys){
    try {
      if (!keys || !keys.length) return '';
      var contexts = [
        '.product-item-v1 .es-wishlist-inline',
        '.product-item-v2 .es-wishlist-inline',
        '.index-sections',
        '[data-es-related-root]',
        '.template-product',
        '.quickview-product',
        '.tshopify-popup'
      ];
      var btnSel = [];
      var pathSel = [];
      for (var i=0;i<keys.length;i++){
        var k = String(keys[i] || '');
        if (!k) continue;
        var type = k.slice(0,2);
        var id = k.slice(2).replace(/"/g,'\"');
        if (!id) continue;
        for (var c=0;c<contexts.length;c++){
          var ctx = contexts[c] + ' ';
          var base;
          if (type === 'v:') {
            base = ctx + 'button.es-wishlist-btn[data-variant-id="' + id + '"]';
          } else if (type === 'p:') {
            // Only for buttons that do NOT have a variant id (avoid marking all variants)
            base = ctx + 'button.es-wishlist-btn[data-product-id="' + id + '"]:not([data-variant-id]):not([data-variant-id=""])';
          } else {
            continue;
          }
          btnSel.push(base);
          pathSel.push(base + ' .es-swym-heart path');
          pathSel.push(base + ' .es-wishlist__icon path');
          pathSel.push(base + ' .es-icon-heart path');
        }
      }
      var css = '';
      if (btnSel.length) css += btnSel.join(',') + '{color:' + ACTIVE + '!important;}';
      if (pathSel.length) css += pathSel.join(',') + '{fill:currentColor!important;stroke:none!important;}';
      return css;
    } catch(e) { return ''; }
  }

  function updatePrestyle(keys){
    try {
      var st = document.getElementById(STYLE_ID);
      if (!st) {
        st = document.createElement('style');
        st.id = STYLE_ID;
        document.head && document.head.appendChild(st);
      }
      st.textContent = buildPreCss(keys);
    } catch(e) {}
  }

  function applyCached(root){
    try {
      var set = ensureSet();
      var scope = root || document;
      if (!scope.querySelectorAll) return;
      var btns = scope.querySelectorAll('button.es-wishlist-btn');
      for (var i=0;i<btns.length;i++) {
        var b = btns[i];
        var k = btnKey(b);
        if (!k) continue;
        setAdded(b, set.has(k));
      }
    } catch(e) {}
  }

  function scheduleSync(ms){
    try { if (__syncTimer) clearTimeout(__syncTimer); } catch(e) {}
    __syncTimer = setTimeout(syncNow, ms || 220);
  }

  function syncNow(){
    try {
      if (!window._swat || typeof _swat.fetchWrtEventTypeET !== 'function') {
        return scheduleSync(600);
      }
      _swat.fetchWrtEventTypeET(function(list){
        try {
          var next = new Set();
          if (Array.isArray(list)) {
            for (var i=0;i<list.length;i++){
              var k = keyFromItem(list[i]);
              if (k) addKey(next, k);
            }
          }
          __esKeySet = next;
          scheduleCacheWrite();
          setHasItemsFlag();
          updatePrestyle(Array.from(__esKeySet));
          applyCached();
          hookClearList();
        } catch(e) {}
      });
    } catch(e) {
      scheduleSync(800);
    }
  }

  // -----------------------
  // Variant-id binding sync
  // -----------------------
  function syncVariantInScope(scope){
    try {
      if (!scope || !scope.querySelector) return;
      var input = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      var btn = scope.querySelector('button.es-wishlist-btn');
      if (!input || !btn) return;

      var vid = norm(input.value || input.getAttribute('value'));
      if (vid) {
        if (btn.getAttribute('data-variant-id') !== vid) {
          btn.setAttribute('data-variant-id', vid);
          try { btn.dataset.variantId = vid; } catch(e) {}
        }
      }
      applyToBtn(btn);
    } catch(e) {}
  }

  function syncAllVariantScopes(){
    try {
      var scopes = document.querySelectorAll('.template-product, .quickview-product, .tshopify-popup');
      for (var i=0;i<scopes.length;i++) syncVariantInScope(scopes[i]);
    } catch(e) {}
  }

  document.addEventListener('change', function(e){
    try {
      var t = e && e.target;
      if (!t || !t.closest) return;
      if (
        t.matches('.single-option-selector') ||
        t.matches('.swatch input[type="radio"]') ||
        t.matches('form[action*="/cart/add"] [name="id"]')
      ) {
        var scope = t.closest('.template-product, .quickview-product, .tshopify-popup') || document;
        setTimeout(function(){
          if (scope === document) syncAllVariantScopes();
          else syncVariantInScope(scope);
        }, 0);
      }
    } catch(e) {}
  }, true);

  // -----------------------
  // Swym event integration
  // -----------------------
  function keyFromEvent(e){
    try {
      var d = e && e.detail;
      if (d) {
        var epi = d.epi || d.variantId || d.variant_id || (d.product && (d.product.epi || d.product.variantId || d.product.variant_id));
        if (epi) return 'v:' + norm(epi);
        var empi = d.empi || d.productId || d.product_id || d.id || (d.product && (d.product.id || d.product.empi || d.product.productId || d.product.product_id));
        if (empi) return 'p:' + norm(empi);
      }
      var tgt = e && e.target;
      if (tgt && tgt.closest) {
        var btn = tgt.closest('button.es-wishlist-btn, .swym-button');
        if (btn) return btnKey(btn);
      }
    } catch(e) {}
    return '';
  }

  document.addEventListener('swym:addedtowishlist', function(e){
    var k = keyFromEvent(e);
    if (!k) return scheduleSync(220);
    ensureSet().add(k);
    scheduleCacheWrite();
    setHasItemsFlag();
    updatePrestyle(Array.from(__esKeySet));
    updateButtonsByKey(k, true);
  });

  document.addEventListener('swym:removedfromwishlist', function(e){
    var k = keyFromEvent(e);
    if (!k) return scheduleSync(220);
    ensureSet().delete(k);
    scheduleCacheWrite();
    setHasItemsFlag();
    updatePrestyle(Array.from(__esKeySet));
    updateButtonsByKey(k, false);
  });

  // Deterministic click: call Swym API first, then update UI/caches ONLY on success.
  // This eliminates the "flash" and prevents swatch switching from breaking variant-level wishlist.
  function callSwymToggle(btn, willAdd, onOk, onErr){
    // Compatibility-first: Swym builds vary (callbacks vs promises, payload schema).
    // We attempt multiple payload shapes and support promise returns.
    try {
      var swat = window.__esSwat || window._swat || window.SwymWishlist || window.swat || null;
      if (!swat) return onErr && onErr('no_swat');

      var epiRaw = norm(btn.getAttribute('data-variant-id') || (btn.dataset && btn.dataset.variantId));
      var empiRaw = norm(btn.getAttribute('data-product-id') || (btn.dataset && btn.dataset.productId));
      var du = norm(btn.getAttribute('data-product-url')) || (window.location && window.location.href) || '';

      var epiNum = parseInt(epiRaw, 10); if (isNaN(epiNum)) epiNum = null;
      var empiNum = parseInt(empiRaw, 10); if (isNaN(empiNum)) empiNum = null;

      var epi = epiNum != null ? epiNum : epiRaw;
      var empi = empiNum != null ? empiNum : empiRaw;

      var payloads = [];
      // Most common Swym schema
      payloads.push({ epi: epi, empi: empi, du: du });
      payloads.push({ epi: epi, empi: empi, du: du, product: { epi: epi, empi: empi, du: du }});
      // Alternate keys seen in some builds
      payloads.push({ variantId: epi, productId: empi, du: du });
      payloads.push({ variant_id: epi, product_id: empi, du: du });
      payloads.push({ productUrl: du, productId: empi, variantId: epi });
      payloads.push({ product: { id: empi, epi: epi, du: du }});

      var addFn = swat.addToWishList || swat.addToWishlist || swat.AddToWishlist || swat.add || null;
      var remFn = swat.removeFromWishList || swat.removeFromWishlist || swat.RemoveFromWishlist || swat.remove || null;

      var called = false;
      var ok = function(res){ if (called) return; called = true; if (onOk) onOk(res); };
      var err = function(e){ if (called) return; called = true; if (onErr) onErr(e); };

      function attachPromise(ret){
        try {
          if (ret && typeof ret.then === 'function') {
            ret.then(ok).catch(err);
            return true;
          }
        } catch(_) {}
        return false;
      }

      function tryCall(fn){
        if (typeof fn !== 'function') return false;
        for (var i=0;i<payloads.length;i++){
          try {
            var ret = fn.call(swat, payloads[i], ok, err);
            if (attachPromise(ret)) return true;
            // Some Swym builds only accept (payload, callback)
            if (!called) {
              try { ret = fn.call(swat, payloads[i], ok); } catch(_) {}
              if (attachPromise(ret)) return true;
            }
            // If no callback/promise, rely on Swym DOM/events to update; don't mark failure.
            return true;
          } catch(e) {
            // Try next payload shape
            continue;
          }
        }
        return false;
      }

      if (willAdd) {
        if (tryCall(addFn)) return true;
      } else {
        if (tryCall(remFn)) return true;
      }

      // Last resort: use a temporary Swym button + scoped init.
      try {
        if (typeof swat.initializeActionButtons !== 'function') return err('no_api');
        var tmp = document.createElement('button');
        var tid = 'es-swym-tmp-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
        tmp.id = tid;
        tmp.type = 'button';
        tmp.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden;';
        tmp.setAttribute('data-with-epi', 'true');
        tmp.setAttribute('data-swaction', willAdd ? 'addToWishlist' : 'removeFromWishlist');
        tmp.className = 'swym-button swym-add-to-wishlist';
        if (empiRaw) tmp.setAttribute('data-product-id', empiRaw);
        if (epiRaw) tmp.setAttribute('data-variant-id', epiRaw);
        if (du) tmp.setAttribute('data-product-url', du);
        document.body.appendChild(tmp);
        swat.initializeActionButtons('#' + tid);
        // Give Swym a tick to bind before clicking.
        setTimeout(function(){
          try { tmp.click(); } catch(_) {}
          setTimeout(function(){ try { tmp.parentNode && tmp.parentNode.removeChild(tmp); } catch(eR) {} }, 0);
          ok({ fallback:true });
        }, 0);
        return true;
      } catch(e3) { return err(e3); }
    } catch(e) { return onErr && onErr(e); }
  }

  document.addEventListener('click', function(e){
    var btn = e && e.target && e.target.closest ? e.target.closest('button.es-wishlist-btn') : null;
    if (!btn) return;
    try { e.preventDefault(); e.stopPropagation(); } catch(_) {}
    var k = btnKey(btn);
    if (!k) return;
    var set = ensureSet();
    applyToBtn(btn);

    if (btn.classList && btn.classList.contains('es-wl-pending')) return;
    btn.classList.add('es-wl-pending');

    // Ensure the spinner is actually visible for at least one paint
    // (some Swym builds call success callbacks synchronously)
    var __esWlT0 = (window.performance && performance.now) ? performance.now() : Date.now();
    var __esWlMinSpin = 180; // ms

    var willAdd = !set.has(k);

    // Wait for Swym's own event to confirm the operation; always release the pending state.
    var done = false;
    var evtName = willAdd ? 'swym:addedtowishlist' : 'swym:removedfromwishlist';
    var tmr = null;

    function finish(confirmed){
      if (done) return;
      done = true;
      try { if (tmr) clearTimeout(tmr); } catch(_) {}
      try { document.removeEventListener(evtName, onEvt, true); } catch(_) {}

      // If the operation is confirmed (via Swym event or success callback),
      // update our local fast-cache BEFORE removing .es-wl-pending.
      // This guarantees: spinner -> instant filled heart (no micro-gap).
      if (confirmed) {
        try {
          if (willAdd) set.add(k); else set.delete(k);
          scheduleCacheWrite();
          setHasItemsFlag();
        } catch(_) {}

        // Update all matching buttons on the page immediately (cards / quickview / PDP).
        try { applyCached(document); } catch(_) {}
        try { syncAllVariantScopes(); } catch(_) {}

        // Ensure this button is already in its final state while the icon is hidden.
        try { applyToBtn(btn); } catch(_) {}

        // Keep pending for a minimum time and guarantee at least one repaint with the spinner,
        // then reveal the final (filled/outline) heart with no micro-gap.
        try {
          var __now = (window.performance && performance.now) ? performance.now() : Date.now();
          var __elapsed = __now - (__esWlT0 || __now);
          var __remain = (__esWlMinSpin || 0) - __elapsed;
          if (__remain < 0) __remain = 0;

          (window.requestAnimationFrame || function(cb){ setTimeout(cb,0); })(function(){
            // rAF runs before paint; setTimeout ensures the pending state paints at least once.
            setTimeout(function(){
              try { btn.classList.remove('es-wl-pending'); } catch(_) {}
            }, __remain);
          });
        } catch(_) {
          try { btn.classList.remove('es-wl-pending'); } catch(_) {}
        }

        // Still reconcile with Swym shortly after to guarantee perfect correctness.
        try { scheduleSync(350); } catch(_) {}
        return;
      }

      // Not confirmed (timeout/error): fall back to syncing from Swym.
      try { btn.classList.remove('es-wl-pending'); } catch(_) {}
      try { scheduleSync(220); } catch(_) {}
      try { applyToBtn(btn); } catch(_) {}
    }

    function onEvt(ev){
      try {
        var kk = keyFromEvent(ev);
        if (kk && kk === k) finish(true);
      } catch(_) {}
    }

    try { document.addEventListener(evtName, onEvt, true); } catch(_) {}
    tmr = setTimeout(function(){ finish(false); }, 1600);

    callSwymToggle(btn, willAdd, function(){ finish(true); }, function(){ finish(false); });
  }, true);

  
  // -----------------------
  // Swym "Clear list" robustness
  // -----------------------
  var __esClearAllHooked = false;
  var __esClearAllInFlight = false;

  function isClearListControl(el){
    try {
      if (!el) return false;
      // ensure this is inside Swym UI
      if (el.closest && !el.closest('.swym-ui-component, .swym-wishlist-container, .swym-wishlist-page')) return false;

      var cls = (el.className || '') + '';
      if (/\bswym\-clear\b/i.test(cls) || /\bclear\-wishlist\b/i.test(cls) || /\bclear\-list\b/i.test(cls) || /\bclearList\b/i.test(cls)) return true;

      var al = (el.getAttribute && (el.getAttribute('aria-label') || el.getAttribute('title') || '')) || '';
      var txt = (al || (el.textContent || '')).trim().toLowerCase();
      // Match the default Swym copy
      if (txt === 'clear list' || txt === 'clear wishlist' || txt === 'clear favorites' || txt === 'clear all') return true;
    } catch(e) {}
    return false;
  }

  function hookClearList(){
    if (__esClearAllHooked) return;
    __esClearAllHooked = true;

    document.addEventListener('click', function(e){
      try {
        var t = e && e.target;
        if (!t || !t.closest) return;
        var btn = t.closest('button, a, [role="button"]');
        if (!btn) return;
        if (!isClearListControl(btn)) return;

        // Let Swym run first, then we verify and force-clear any residue.
        setTimeout(esForceClearWishlistResidue, 900);
        setTimeout(esForceClearWishlistResidue, 1900);
      } catch(_) {}
    }, true);
  }

  function getSwat(){
    return window.__esSwat || window._swat || window.SwymWishlist || window.swat || window._swym || null;
  }

  function callSwymRemove(payload, cb){
    var swat = getSwat();
    if (!swat) return cb && cb(false);

    var remFn = swat.removeFromWishList || swat.removeFromWishlist || swat.RemoveFromWishlist || swat.remove || swat.Remove || null;
    if (typeof remFn !== 'function') return cb && cb(false);

    var epi = payload && payload.epi;
    var empi = payload && payload.empi;
    var du = payload && payload.du;

    var payloads = [];
    payloads.push({ epi: epi, empi: empi, du: du });
    payloads.push({ epi: epi, empi: empi, du: du, product: { epi: epi, empi: empi, du: du }});
    payloads.push({ variantId: epi, productId: empi, du: du });
    payloads.push({ variant_id: epi, product_id: empi, du: du });
    payloads.push({ productUrl: du, productId: empi, variantId: epi });
    payloads.push({ product: { id: empi, epi: epi, du: du }});

    var done = false;
    var ok = function(){ if (done) return; done = true; if (cb) cb(true); };
    var err = function(){ if (done) return; done = true; if (cb) cb(false); };

    function attachPromise(ret){
      try {
        if (ret && typeof ret.then === 'function') { ret.then(ok).catch(err); return true; }
      } catch(_) {}
      return false;
    }

    for (var i=0;i<payloads.length;i++){
      try {
        var ret = remFn.call(swat, payloads[i], ok, err);
        if (attachPromise(ret)) return;
        if (!done) {
          try { ret = remFn.call(swat, payloads[i], ok); } catch(_) {}
          if (attachPromise(ret)) return;
        }
        // If Swym doesn't use callbacks/promises, rely on its events; consider it "attempted".
        if (!done) { done = true; if (cb) cb(true); }
        return;
      } catch(e) {}
    }

    if (!done) { done = true; if (cb) cb(false); }
  }

  function idsFromItem(it){
    try {
      var epi = it && (it.epi || it.variantId || it.variant_id || (it.product && (it.product.epi || it.product.variantId || it.product.variant_id)));
      var empi = it && (it.empi || it.productId || it.product_id || (it.product && (it.product.empi || it.product.productId || it.product.product_id || it.product.id)));
      var du = it && (it.du || it.productUrl || it.product_url || (it.product && (it.product.du || it.product.productUrl || it.product.product_url)));
      if (!du) du = (window.location && window.location.href) || '';
      return { epi: epi, empi: empi, du: du };
    } catch(e) {}
    return { epi: null, empi: null, du: (window.location && window.location.href) || '' };
  }

  function esForceClearWishlistResidue(){
    try {
      if (__esClearAllInFlight) return;
      // Only proceed if Swym is available
      if (!window._swat || typeof _swat.fetchWrtEventTypeET !== 'function') return;

      __esClearAllInFlight = true;

      _swat.fetchWrtEventTypeET(function(list){
        try {
          if (!Array.isArray(list) || list.length === 0) {
            // Ensure local UI/caches are truly empty
            ensureSet().clear();
            scheduleCacheWrite();
            setHasItemsFlag();
            updatePrestyle([]);
            applyCached();
            try { if (window.esWishlistClearAllHearts) window.esWishlistClearAllHearts(); } catch(_) {}
            return;
          }

          var items = [];
          for (var i=0;i<list.length;i++){
            var ids = idsFromItem(list[i]);
            if (ids && (ids.epi || ids.empi)) items.push(ids);
          }

          // Fallback: use cached key set if fetch list items have no ids (rare)
          if (!items.length && __esKeySet && __esKeySet.size) {
            __esKeySet.forEach(function(k){
              if (k && k.indexOf('v:') === 0) items.push({ epi: k.slice(2), empi: null, du: (window.location && window.location.href) || '' });
              else if (k && k.indexOf('p:') === 0) items.push({ epi: null, empi: k.slice(2), du: (window.location && window.location.href) || '' });
            });
          }

          var idx = 0;
          function next(){
            if (idx >= items.length) {
              // Re-sync from Swym after removals to avoid ghost items
              scheduleSync(250);
              return;
            }
            var it = items[idx++];
            callSwymRemove(it, function(){
              setTimeout(next, 30);
            });
          }
          next();
        } catch(e) {
          // If anything goes wrong, re-sync as a safe fallback.
          scheduleSync(450);
        }
      });
    } catch(e) {
      // no-op
    } finally {
      // allow another pass (we schedule 2 passes) after a short cooldown
      setTimeout(function(){ __esClearAllInFlight = false; }, 600);
    }
  }

  function isCollectionGridPage(){
    try {
      var b = document.body;
      if (!b || !b.classList) return false;
      return b.classList.contains('template-collection') || b.classList.contains('template-search');
    } catch(e) {}
    return false;
  }

  function scheduleInitialSync(){
    if (!isCollectionGridPage()) {
      scheduleSync(450);
      return;
    }

    // Collection/search pages render many wishlist buttons at once.
    // A fast Swym re-sync right after first paint can cause a visible flash.
    var run = function(){ scheduleSync(1200); };

    if (document.readyState === 'complete') {
      if (window.requestIdleCallback) {
        try { window.requestIdleCallback(run, { timeout: 1800 }); return; } catch(e0) {}
      }
      setTimeout(run, 1200);
      return;
    }

    window.addEventListener('load', function onLoad(){
      try { window.removeEventListener('load', onLoad); } catch(_) {}
      if (window.requestIdleCallback) {
        try { window.requestIdleCallback(run, { timeout: 1800 }); return; } catch(e1) {}
      }
      setTimeout(run, 1200);
    }, { once:true });
  }

  // Initial hydrate
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      ensureSet();
      setHasItemsFlag();
      updatePrestyle(Array.from(__esKeySet));
      applyCached();
      syncAllVariantScopes();
      scheduleInitialSync();
      observe();
    });
  } else {
    ensureSet();
    setHasItemsFlag();
    updatePrestyle(Array.from(__esKeySet));
    applyCached();
    syncAllVariantScopes();
    scheduleInitialSync();
    observe();
  }

  function shouldQuietObserverSync(root){
    if (!isCollectionGridPage()) return false;
    try {
      var el = root && root.nodeType === 1 ? root : null;
      if (!el) return true;
      if (el.matches && el.matches('.product-item, .product-item-v1, .js_size_prod, .collection_prod, .grid-uniform')) return true;
      if (el.closest && el.closest('.collection-page-fullwidth, .collection-page-sidebar, .collection-page-fullwidth-sty2, .template-collection, .template-search')) return true;
      if (el.querySelector && el.querySelector('.product-item, .product-item-v1, .js_size_prod, .collection_prod, .grid-uniform')) return true;
    } catch(e) {}
    return false;
  }

  function observe(){
    try {
      var container = document.body || document.documentElement;
      if (!container || !window.MutationObserver) return;
      if (window.__esSwymUnifiedObserverBound) return;
      window.__esSwymUnifiedObserverBound = true;
      var pending = false;
      var nextRoot = null;
      function schedule(cb){
        if (window.requestIdleCallback) return window.requestIdleCallback(cb, { timeout: 250 });
        return (window.requestAnimationFrame || function(fn){ return setTimeout(fn, 16); })(cb);
      }
      function isRelevantNode(node){
        try {
          if (!node || node.nodeType !== 1) return false;
          if (node.matches && node.matches('button.es-wishlist-btn, .swym-wishlist-header-counter, [data-product-id], [data-variant-id], .product-item, .quickview-product')) return true;
          return !!(node.querySelector && node.querySelector('button.es-wishlist-btn, .swym-wishlist-header-counter, [data-product-id], [data-variant-id], .product-item, .quickview-product'));
        } catch(e) { return false; }
      }
      var mo = new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){
          var added = muts[i].addedNodes;
          if (!added || !added.length) continue;
          for (var j=0;j<added.length;j++){
            if (!isRelevantNode(added[j])) continue;
            nextRoot = muts[i].target || added[j] || document;
            if (pending) return;
            pending = true;
            schedule(function(){
              var root = nextRoot || document;
              var quiet = shouldQuietObserverSync(root);
              pending = false;
              applyCached(root);
              if (!quiet) scheduleSync(220);
              nextRoot = null;
            });
            return;
          }
        }
      });
      mo.observe(container, {childList:true, subtree:true});
    } catch(e) {}
  }
})();


function renderWishlistCounter(swat) {
	var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter"); /* Custom header can be added here.*/
	if (counter_elem) {
		for (var i = 0; i < counter_elem.length; i++) {
			if (swat.renderWishlistCount) {
				swat.renderWishlistCount(counter_elem[i], function(count, element) {
					// Ensure "0" is not shown, and keep mobile/desktop behavior consistent.
					try {
						var n = parseInt(count, 10) || 0;
					// Mark as hydrated so other scripts can safely persist state.
					if (element && element.setAttribute) element.setAttribute('data-es-wl-ready','1');

					// Persist a fast "has items" flag to avoid badge flicker on navigation.
					try {
					  var k = 'es_swym_wishlist_has_items';
					  if (window.localStorage) localStorage.setItem(k, n > 0 ? '1' : '0');
      
      // ES: Persist a CONFIRMED cache for fast, no-flash header dot on navigation.
      try {
        if (window.localStorage) {
          localStorage.setItem('es_wl_confirmed_has_items', n > 0 ? '1' : '0');
          localStorage.setItem('es_wl_confirmed_count', String(n));
          localStorage.setItem('es_wl_confirmed_ts', String(Date.now()));
        }
      } catch (e) {}
      try {
        var root = document.documentElement;
        if (root && root.classList) {
          if (n > 0) root.classList.add('es-wishlist-has-items');
          else root.classList.remove('es-wishlist-has-items');
        }
      } catch (e) {}
// ES: do not drive header badge from cached keys (prevents false flash on empty wishlist).
					  if (n === 0 && window.esWishlistClearAllHearts) window.esWishlistClearAllHearts();
					} catch (e) {}

						var isMobile = element && element.classList && element.classList.contains('swym-mobile');
						if (!element || !element.classList) return;

						if (n > 0) {
							element.classList.add('show-badge');
							// Mobile: show numeric badge (cap at 9+). Desktop: keep as dot.
							if (isMobile) {
								element.textContent = (n > 9) ? '9+' : String(n);
							} else {
								element.textContent = '';
							}
						} else {
							element.classList.remove('show-badge');
							element.textContent = '';
						}
					} catch (e) {
						// no-op
					}
				});
			}
		}
	}
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
if (!window.__esSwymCounterCallbackAdded) {
	window.__esSwymCounterCallbackAdded = true;
	window.SwymCallbacks.push(renderWishlistCounter);
}
